import { useNavigate, useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { api, ApiError } from "@/api/client";
import { queryKeys } from "@/hooks/queryKeys";
import { PageShell } from "@/components/PageShell";
import { BrandHeader } from "@/components/BrandHeader";
import { Button } from "@/components/Button";
import { useToast } from "@/components/toast/ToastProvider";
import "./edge.css";

export function TripDeletedScreen() {
  const { slug = "" } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const qc = useQueryClient();
  const toast = useToast();

  async function handleRestore() {
    try {
      await api.restoreTrip(slug);
      await qc.invalidateQueries({ queryKey: queryKeys.trip(slug) });
      navigate(`/t/${slug}`);
    } catch (err) {
      if (err instanceof ApiError && (err.status === 410 || err.status === 404)) {
        navigate(`/t/${slug}/gone`);
        return;
      }
      toast.push({ tone: "error", title: "Не вдалось відновити" });
    }
  }

  return (
    <PageShell header={<BrandHeader />}>
      <section className="wp-edge">
        <div className="wp-edge__glyph" aria-hidden="true">⏳</div>
        <h1 className="wp-edge__title">Цю поїздку видалили</h1>
        <p className="wp-edge__hint">
          Відновити можна протягом 7 днів. Після цього поїздку повернути не вдасться.
        </p>
        <Button size="lg" onClick={handleRestore}>
          Відновити поїздку
        </Button>
        <Button variant="ghost" onClick={() => navigate("/")}>
          Закрити цю сторінку
        </Button>
      </section>
    </PageShell>
  );
}
